import React from "react";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';

export default function DHIconUp({fontSize, style}) {

    return <ArrowCircleUpIcon sx={{ fontSize: fontSize }} style={{...style}}/>
}